import req from './../../../fetch';
import { undocumentedResponse } from './../../../utils';
import { FilterType, AllAPIResponses, CarbonError } from './../../../index';

type Payload = {
  analysis: string;
  channelName: string;
  endTime?: string;
  startTime?: string;
  filters?: FilterType[];
  nodeId: number;
  uniqueId: number;
};
const post = async (
  payload: Payload,
  headers?: Headers
): Promise<AllAPIResponses<any>> => {
  try {
    const resp = await req.post(
      '/api/applications',
      JSON.stringify(payload),
      headers
    );
    const clone = resp.clone();
    switch (resp.status) {
      case 200:
        return { data: (await resp.json()) as any, response: clone };
      case 400:
      case 401:
      case 403:
      case 404:
      case 500:
        return {
          error: (await resp.json()) as CarbonError,
          response: clone,
        };
      default:
        return {
          error: new Error(undocumentedResponse(resp)),
          response: clone,
        };
    }
  } catch (e) {
    return { error: e, response: undefined };
  }
};

export default post;
